import { render } from "./DiagnosisScreenManageList.vue?vue&type=template&id=636e8091&scoped=true"
import script from "./DiagnosisScreenManageList.vue?vue&type=script&lang=js"
export * from "./DiagnosisScreenManageList.vue?vue&type=script&lang=js"

import "./DiagnosisScreenManageList.vue?vue&type=style&index=0&id=636e8091&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636e8091"]])

export default __exports__